import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';

const BackdropModalSmall = ({ open, handleClose, children, modalTitle }) => {
    return (
        // onClose={handleClose}
        <Dialog fullWidth={true} maxWidth="sm" open={open}  scroll="body">
            <div className='d-flex justify-content-end'>
                <div className='position-absolute'> 
                    <button type="button" className='btn btn-sm ms-4 border-0' onClick={handleClose}><i className="bx bx-x fs-2"  > </i></button>
                </div>
            </div>
            <DialogTitle className='pb-0'>{modalTitle}

   
            </DialogTitle>
            <DialogContent >
                <DialogContentText>
                    
                </DialogContentText>
                <Box noValidate component="form"
                    sx={{
                        display      : 'flex',
                        flexDirection: 'column',
                        // width        : 'fit-content',
                        height       : 'auto'
                    }}>

                    <FormControl sx={{ mt: 2, minWidth: 100 }}>
                        {children}
                    </FormControl>
                </Box>
            </DialogContent>
          
        </Dialog>
    );
}

export default BackdropModalSmall;
